import { render, staticRenderFns } from "./ListSerialDetail.vue?vue&type=template&id=284a6a00&"
import script from "./ListSerialDetail.vue?vue&type=script&lang=js&"
export * from "./ListSerialDetail.vue?vue&type=script&lang=js&"
import style0 from "./ListSerialDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListNewsItem: require('/app/components/list/ListNewsItem.vue').default})
